// Universal status taxonomy for every programme, project and experience
// across Temple of Kulture. One source of truth so badges, CTAs and
// admin reports stay consistent.

import { Calendar, Ticket, BellRing, Hammer, Sparkles, Handshake } from "lucide-react";

export const STATUS = {
  LIVE_NOW: "live-now",
  BOOKING_OPEN: "booking-open",
  REGISTER_INTEREST: "register-interest",
  IN_DEVELOPMENT: "in-development",
  COMING_SOON: "coming-soon",
  FUTURE_VISION: "future-vision",
};

// Display + behaviour metadata per status. UI components consume this
// instead of branching on the string literal.
export const STATUS_META = {
  [STATUS.LIVE_NOW]: {
    label: "Live Now",
    pulse: true,
    badgeClass:
      "bg-amber-400 text-black border-amber-400",
    Icon: Calendar,
    ctaLabel: "Explore",
    ctaIntent: "primary", // route to a real URL
  },
  [STATUS.BOOKING_OPEN]: {
    label: "Booking Open",
    pulse: false,
    badgeClass: "bg-amber-400 text-black border-amber-400",
    Icon: Ticket,
    ctaLabel: "Book Now",
    ctaIntent: "primary",
  },
  [STATUS.REGISTER_INTEREST]: {
    label: "Register Interest",
    pulse: false,
    badgeClass:
      "bg-transparent text-amber-300 border-amber-400/60",
    Icon: BellRing,
    ctaLabel: "Register Interest",
    ctaIntent: "form", // open interest modal
  },
  [STATUS.IN_DEVELOPMENT]: {
    label: "In Development",
    pulse: false,
    badgeClass:
      "bg-transparent text-cyan-300 border-cyan-400/60",
    Icon: Hammer,
    ctaLabel: "Notify Me",
    ctaIntent: "form",
  },
  [STATUS.COMING_SOON]: {
    label: "Coming Soon",
    pulse: true,
    badgeClass:
      "bg-transparent text-cyan-300 border-cyan-400/60",
    Icon: Sparkles,
    ctaLabel: "Notify Me When Launched",
    ctaIntent: "form",
  },
  [STATUS.FUTURE_VISION]: {
    label: "Future Vision",
    pulse: false,
    badgeClass:
      "bg-transparent text-zinc-300 border-zinc-500/60 border-dashed",
    Icon: Handshake,
    ctaLabel: "Partner With Us",
    ctaIntent: "form",
  },
};

export function getStatusMeta(status) {
  return STATUS_META[status] || STATUS_META[STATUS.REGISTER_INTEREST];
}
